export const SET_ADBLOCK_DETECTED = 'SET_ADBLOCK_DETECTED';
